import L from "leaflet"
export const images = {
    adzLogo: require("./Logo.png"),
    chart: "M678.4 938.667v-682.667h166.4v682.667h-166.4zM426.667 85.333h170.667v853.333h-170.667v-853.333zM179.2 512h166.4v426.667h-166.4v-426.667z",
    map: "M512 938.667c0 0-354.133-290.133-354.133-507.733 0-192 157.867-345.6 354.133-345.6s354.133 153.6 354.133 345.6c0 217.6-354.133 507.733-354.133 507.733zM512 281.6c-85.333 0-153.6 68.267-153.6 149.333 0 85.333 68.267 149.333 153.6 149.333s153.6-68.267 153.6-149.333c0-81.067-68.267-149.333-153.6-149.333z",
    noti: "M512 938.667c46.933 0 85.333-38.4 85.333-85.333h-170.667c0 46.933 37.973 85.333 85.333 85.333zM768 682.667v-213.333c0-130.987-69.973-240.64-192-269.653v-29.013c0-35.413-28.587-64-64-64s-64 28.587-64 64v29.013c-122.453 29.013-192 138.24-192 269.653v213.333l-85.333 85.333v42.667h682.667v-42.667l-85.333-85.333z",
    dot:require("./dot.png"),
};
export const devIcon = new L.Icon({
  	iconUrl:images.dot,
  	iconAnchor: [10,20],
});


// WEBPACK FOOTER //
// ./src/_assets/img/images.js